// import logo from './logo.svg';
import './style/App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Login from './pages/Login/Login';
import Portal from './pages/Portal/Portal';
import NotFound from './pages/NotFound/NotFound';

function App() {
    return (
        <div className="appContents">
            <Router>
                <Switch>
                    <Route exact path="/" component={Login} />
                    <Route exact path="/portal" component={Portal} />
                    <NotFound></NotFound>
                </Switch>
            </Router>
        </div>
    );
}

export default App;
